import { Icon, Intent, Props, Tag } from '@blueprintjs/core'
import { DateRange } from '@blueprintjs/datetime'
import classNames from 'classnames'
import * as React from 'react'
import { formatDate, isValidDate, DATE_LOCALE_LONG, DATE_LOCALE_WITH_TIME } from '../utils/dateHelpers'

export const MomentDate: React.SFC<{ date: Date; format?: string; withTime?: boolean }> = ({
  date,
  withTime = false,
  format = withTime ? DATE_LOCALE_WITH_TIME : DATE_LOCALE_LONG
}) => {
  if (isValidDate(date)) {
    return <Tag intent={Intent.PRIMARY}>{formatDate(date, format)}</Tag>
  }
  return <Tag minimal>no date selected</Tag>
}

export const MomentDateRange: React.SFC<{ range: DateRange; format?: string; withTime?: boolean } & Props> = ({
  className,
  range: [start, end],
  withTime = false,
  format = withTime ? DATE_LOCALE_WITH_TIME : DATE_LOCALE_LONG
}) => (
  <div className={classNames('date-range-tag-wrapper', className)}>
    <MomentDate withTime={withTime} date={start || null} format={format} />
    <Icon icon="arrow-right" />
    <MomentDate withTime={withTime} date={end || null} format={format} />
  </div>
)
